// --------------------------------------------------------------------------
// timetable.js
// --------------------------------------------------------------------------

RN.timetable = function() {

    var experience,
        timetable = byElement('timetable'),
        input = timetable.find(byBehaviour('add-to-timetable')),
        extraFee = byElement('extra-fee');

    function init() {
        input.on('change', checkPremium);
        experience = timetable.data('type');
    }

    function checkPremium() {
        var additional = $(this).parents(byElement('additional-listing'));

        if(experience == 1 || experience == 10) {
            var compare = 1;
            if(experience == 10) {
                compare = 0;
            }
            var i = 0;
            input.each(function(){
                if(this.checked){
                    $(this).parent().find(byElement('extra-fee')).hide();
                    i++;
                }
                else{
                    $(this).parent().find(byElement('extra-fee')).show();
                }
            });
            if(i == 0){ //<= compare){
                extraFee.hide();
            }
            console.log(i);
        }
    }

  return {
    init: init
  };

}();

